/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2019-2025 (original work) Open Assessment Technologies SA ;
 */

import { routingTable, router } from '@/core';
import { locale } from '@/core/utils';
import { __ } from '@oat-sa-private/ui-core';
import '@oat-sa-private/ui-identity/css/main.css';
import packageJson from '../package.json';
import { log } from './core/utils';
import './locale/beMessages';

window.__VERSION = packageJson.version;

__.setDictionaryLoader(localeCode =>
    import(`./locale/${localeCode}/messages.json`).then(dictionaryModule => dictionaryModule.default)
);

async function start() {
    try {
        const localeCode = await locale.getStoredCode();
        locale.setApplicationLocale(localeCode);
        locale.setLangAttribute(localeCode);
    } catch (error) {
        log.error(error);
    }

    await router.start(routingTable);
}

start();
